import { House } from '@phosphor-icons/react';
import { buttonStyles, Heading, Text } from '@shh/ui';
import { Link } from 'react-router';
import { appText } from '../i18n/app';

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-narrow flex-col items-start justify-center gap-gap-lg px-safe">
      <Heading level={1} size="xl">
        {appText.notFoundTitle}
      </Heading>
      <Text tone="secondary">{appText.notFoundText}</Text>
      <Link to="/" className={buttonStyles({ variant: 'primary' })}>
        <House aria-hidden className="size-icon-md" weight="duotone" />
        {appText.toStart}
      </Link>
    </main>
  );
}
